<div class="no-delegations flex-col justify-center items-center">
    <div class="message" data-qa-id="no-delegations-message">Assigned delegations are only available from your main profile, {{mainProfileUserName}}.</div>
    <div class="space">
        <button type="button" data-qa-id="switch-to-main-profile-button" class="button" (click)="switchToMainProfile(mainProfileUserId)">
            SWITCH TO MAIN PROFILE</button>
    </div>
</div>
